// extracted by mini-css-extract-plugin
export var container = "_ed-0";
export var icon = "_ed-1";
export var text = "_ed-2";